import React, { useEffect, useState } from "react";
import { PhoneMissed, UtensilsCrossed } from "lucide-react";
import { useI18n } from "../../i18n/I18nContext";

export const RestaurantDemo = () => {
  const { t } = useI18n();
  const [visible, setVisible] = useState([]);

  useEffect(() => {
    const msgs = t.restoDemo.messages;
    setVisible([msgs[0]]);
    const id = setInterval(() => {
      setVisible((v) => {
        if (v.length >= msgs.length) {
          clearInterval(id);
          return v;
        }
        return [...v, msgs[v.length]];
      });
    }, 1900);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t.restoDemo.messages]);

  return (
    <section className="py-20 lg:py-24" data-testid="restaurant-demo-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-10">
          <div className="flex items-center gap-2 mb-3">
            <UtensilsCrossed size={14} className="text-cyan-300" />
            <div className="eyebrow">{t.restoDemo.eyebrow}</div>
          </div>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight">{t.restoDemo.title}</h2>
          <p className="text-slate-400 mt-4 text-lg">{t.restoDemo.sub}</p>
        </div>

        <div className="glass-strong rounded-2xl p-5 sm:p-7 max-w-3xl mx-auto" data-testid="restaurant-demo-chat">
          <div className="flex items-center justify-between mb-5 pb-4 border-b border-white/10">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-red-500 to-orange-500 flex items-center justify-center text-white font-bold text-sm">TB</div>
              <div>
                <div className="text-white font-semibold text-sm">{t.restoDemo.businessName}</div>
                <div className="text-xs text-slate-400 flex items-center gap-1.5"><span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse-dot" />{t.demo.aiStatus}</div>
              </div>
            </div>
            <div className="text-[10px] font-mono text-slate-500 tracking-widest">TP-AGENT</div>
          </div>

          <div className="space-y-3 min-h-[380px]">
            {visible.map((m, i) => {
              if (m.from === "system") {
                return (
                  <div key={m.text} className="flex items-center justify-center gap-2 text-xs text-red-300 bg-red-500/10 border border-red-500/20 rounded-lg py-2 px-3 mx-auto w-fit animate-fade-up">
                    <PhoneMissed size={14} />{m.text}
                  </div>
                );
              }
              const isAI = m.from === "ai";
              return (
                <div key={m.text} className={`flex ${isAI ? "justify-start" : "justify-end"} animate-fade-up`}>
                  <div className={`max-w-[80%] rounded-2xl px-4 py-2.5 ${isAI ? "bg-blue-600 text-white rounded-bl-sm" : "bg-white/10 text-white rounded-br-sm border border-white/10"}`}>
                    <div className="text-sm leading-snug">{m.text}</div>
                    <div className={`text-[10px] mt-1 ${isAI ? "text-blue-100" : "text-slate-400"}`}>{m.t}</div>
                  </div>
                </div>
              );
            })}
            {visible.length < t.restoDemo.messages.length && (
              <div className="flex justify-start">
                <div className="bg-blue-600/40 rounded-2xl rounded-bl-sm px-4 py-3 flex gap-1">
                  <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse-dot" />
                  <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse-dot" style={{ animationDelay: "0.2s" }} />
                  <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse-dot" style={{ animationDelay: "0.4s" }} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
